import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityProvider } from 'app/providers/utility/utility';
import { DataManagement } from 'app/services/dataManagement';
import { GlobalService } from 'app/services/globalService';
import { RestWS } from 'app/services/restService';

@Component({
  selector: 'app-nuevacamp',
  templateUrl: './nuevacamp.component.html',
  styleUrls: ['./nuevacamp.component.scss']
})
export class NuevacampComponent implements OnInit {

  loading: boolean = false;
  muestraPrompt: boolean = false;
  prompt: string = '';
  muestraTipificaciones: boolean = false;
  muestraVoces: boolean = false;
  vozActual: string = 'UOIqAnmS11Reiei1Ytkc'; // Carolina
  textoIa: string = '';
  textoBoton: string = 'Generar Voz';

 
  
  async enviarCamp() {
    this.loading = true;
      /*let tagInput = document.getElementById('name') as HTMLInputElement;
      let name = tagInput.value;
      tagInput = document.getElementById('cif') as HTMLInputElement;
      let cif = tagInput.value;
      tagInput = document.getElementById('email') as HTMLInputElement;
      let email = tagInput.value;*/
      let tag = document.getElementById('saludo') as HTMLTextAreaElement;
      let saludo = tag.value;
      tag = document.getElementById('contexto') as HTMLTextAreaElement;
      let contexto = tag.value;
      tag = document.getElementById('indicadores') as HTMLTextAreaElement;
      let indicadores = tag.value;
      let body = {
        cif: this.globalService.clienteAivoz.cif,
        name: this.globalService.clienteAivoz.razonSocial,
        email: this.globalService.clienteAivoz.email,
        saludo: saludo,
        contexto: contexto,
        indicadores: indicadores
      }

      this.globalService.campaignAivoz.saludo = saludo;
      this.globalService.campaignAivoz.prompt = contexto;
      this.globalService.campaignAivoz.indicadores = indicadores;

      let sendEmail = await this.api.sendMail(body);
      await this.api.updateAivozCampaign(this.globalService.campaignAivoz);
      this.utils.openDialog("Campaña actualizada con éxito.", "Se ha enviado al administrador para su revisión.", false, false);
  }

 

  constructor(public globalService: GlobalService ,public utils: UtilityProvider, public api: RestWS, public router: Router) { }

  async ngOnInit() {
    
    if (!this.globalService.cliente) {
      this.router.navigateByUrl("/pages/auth/login");
    }
    console.log('Campaign actual: ', this.globalService.campaignAivoz);
    console.log('Cliente actual: ', this.globalService.clienteAivoz);
    setTimeout(() => {
      let tag = document.getElementById('saludo') as HTMLTextAreaElement;
      tag.value = this.globalService.campaignAivoz.saludo;
      tag = document.getElementById('contexto') as HTMLTextAreaElement;
      tag.value = this.globalService.campaignAivoz.prompt;
      tag = document.getElementById('indicadores') as HTMLTextAreaElement;
      tag.value = this.globalService.campaignAivoz.indicadores;
    }, 500)
  }

}
